/**
 * erp目录下的RC.util相关方法都在这引入
 */
import RC_Util_picPath from '@@c/control.util.picPath.js';
import RC_Util_tool from '@@c/control.util.tool.js';

export const adaptRCUtil = () => {
    RC_Util_picPath.init();
    RC_Util_tool.init();
}

export default {
    adaptRCUtil
}